<template>
    <div class="border rounded p-2 shadow">
        <h4>Результаты:</h4>
        <div v-for="p in internalList" class="row px-3" :key="p.id">
            <div class="form-group col-1">
                <div class="checkbox-radios">
                    <base-checkbox :checked="p.required" inline @input="updateProp(p.id, 'required', $event)">*</base-checkbox>
                </div>
            </div>
            <div class="col-md-5 form-group">
				<div class="mb-0">
					<input type="text" class="form-control" :value="p.name" @input="updateProp(p.id, 'name', $event.target.value)">
				</div>		
			</div>

            <label class="col-form-label"> <span>тип :</span></label>
            <div class="col-md-4 d-flex form-group">
                <el-select 
                    class="select-primary mr-2"
                    :value="p.type" 
                    placeholder="Укажите тип"
                    @input="updateProp(p.id, 'type', $event)"
                    size="large"
                    filterable
                    clearable
                >
                    <el-option
                        class="select-primary"
                        v-for="(m) in Object.keys(types)"
                        :key="m"
                        :label="types[m]"
                        :value="m"
                        >
                    </el-option>
                </el-select>
            </div>

            <template v-if="p.type=='enum'||p.type=='arrayEnum'">
                <div class="col-md-4 form-group">
                    <div class="mb-0">
                        <input type="text" class="form-control" :value="p.enum" @input="updateProp(p.id, 'enum', $event.target.value)" placeholder="Список вариантов через запятую" >
                    </div>		
                </div>
            </template>
            <div class="col-1">
                <base-button type="danger" class="my-0" simple icon v-on:click="remove(p)"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
            </div>

            <div v-if="p.type=='arrayObject'||p.type=='object'" class="col-12">
                <REAIQueryProps 
                    :value="p.props" 
                    @input="updateProp(p.id, 'props', $event)"
                />
            </div>              

        </div>

        <div class="dflex">
            <base-button class="sm" type="success" simple  @click="Add()">Добавить результат</base-button>
        </div>
    </div>
</template>
<script>
import { Select, Option, Button } from 'element-ui';
import { BaseCheckbox } from 'src/components/index';

export default {
    name:'REAIQueryProps',
    components:{
        [Option.name]: Option,
        [Select.name]: Select,
        BaseCheckbox,
    },
    props: {
        value: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            internalList: this.value.map(obj => ({ ...obj })),
            types:{
                string:'Строка',
                integer:'Число',
                number:'Вещественное',
                object:'Объект',
                boolean:'Логический',
                enum:'Перечисление',
                date:'Дата',
                datetime:'Дата и Время',
                time:'Время',
                arrayString:'массив строк',
                arrayInt:'Массив чисел',
                arrayEnum:'Массив перечислений',
                arrayObject:'Массив результатов',
                // test_callView:'Звонок или встреча',
            },
        }
    },
    watch: {
        value: {
            handler(newVal) {
                // Синхронизируем при внешнем изменении
                this.internalList = newVal.map(obj => ({ ...obj }))
            },
            deep: true
        }
  },
  methods: {
    updateList(newValue){
        this.internalList = newValue;
        this.$emit('input', newValue);
    },
    Add(){
        const newProp = {
            id: this.$GVO.getId(), // или получите из props, или используйте внешнюю функцию
            name: '',
            required: false,
            type: 'string',
            props:[],
        };

        const updatedList = [...this.internalList, newProp];
        this.updateList(updatedList);

    },
    remove(p) {
        const index = this.internalList.indexOf(p);
        if (index === -1) return;

        // Создаём новый массив БЕЗ удаляемого элемента
        const updatedList = [
            ...this.internalList.slice(0, index),
            ...this.internalList.slice(index + 1)
        ];
        
        this.updateList(updatedList);

    },
    updateProp(id, field, newValue) {
      const index = this.internalList.findIndex(item => item.id === id);
      if (index === -1) return;

      // Создаём обновлённый объект
      const updatedItem = { ...this.internalList[index], [field]: newValue };

      // Создаём новый массив
      const updatedList = [
        ...this.internalList.slice(0, index),
        updatedItem,
        ...this.internalList.slice(index + 1)
      ];

      this.updateList(updatedList);
    },
  }
}
</script>